import { Action } from './action.model';

export class Menu {
    constructor(public items: Action[]) { }
}



// WEBPACK FOOTER //
// /opt/build/repo/src/app/common/ng-structures/menu/menu.model.ts